import React from 'react';
import { VictoryChart, VictoryLine, VictoryAxis } from 'victory';
import { assign } from 'lodash';

// Colors
const grey = '#D8D8D8';
const blue = '0779AF';

// Layout
const padding = 8;
const baseProps = {
  width: 350,
  height: 350,
  padding: 50
};

// * Labels
const baseLabelStyles = {
  padding,
  fill: grey,
  stroke: 'transparent',
  strokeWidth: 0
};

// Strokes
const strokeDasharray = 'none';

// Theme object set up
const theme = {
  axis: assign(
    {
      style: {
        axis: {
          fill: 'transparent',
          stroke: grey,
          strokeWidth: 2
        },
        grid: {
          fill: 'none',
          stroke: grey,
          strokeDasharray,
          pointerEvents: 'painted',
          strokeWidth: 1
        },
        ticks: {
          fill: 'transparent',
          size: 5,
          stroke: 'none',
          strokeWidth: 1
        },
        tickLabels: assign({}, baseLabelStyles, {
          fill: grey
        })
      }
    },
    baseProps
  ),
  chart: baseProps,
  line: assign(
    {
      style: {
        data: {
          fill: 'transparent',
          opacity: 1,
          stroke: grey,
          strokeWidth: 2
        }
      }
    },
    baseProps
  )
};

const CurveThumbnail = ({ curveData }) => {
  const formattedCurveData = curveData.map(coord => {
    return {
      x: coord.xvalue,
      y: coord.yvalue
    };
  });

  return (
    <VictoryChart theme={theme}>
      <VictoryAxis
        crossAxis
        standalone={false}
        style={{
          axis: {
            stroke: 'none'
          }
        }}
        tickFormat={() => ''}
      />
      <VictoryAxis
        dependentAxis
        crossAxis
        standalone={false}
        style={{
          axis: {
            stroke: 'none'
          }
        }}
        tickFormat={() => null}
      />
      <VictoryLine
        data={formattedCurveData}
        style={{
          data: {
            strokeWidth: 10,
            strokeDasharray: 'none',
            stroke: blue
          }
        }}
        sortKey={0}
      />
    </VictoryChart>
  );
};

export default CurveThumbnail;
